import { CheckCircleFilled } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, semanticColors } from '@revenuemarket/design';
import { Modal, ModalProps, Typography } from 'antd';

import { css } from '~libs/emotion';

interface Props extends ModalProps {
  emails: string[];
}

const ConnectSuccessModal: React.FC<Props> = ({ emails = [], ...props }) => {
  return (
    <Modal
      closable={false}
      open={props.open}
      onCancel={props.onCancel}
      onOk={props.onOk}
      okText="확인"
      okButtonProps={{}}
      className={css`
        & .ant-modal-footer {
          display: flex;
          justify-content: center;
          padding: 24px 0px;
        }
      `}
      cancelButtonProps={{
        style: {
          display: 'none',
        },
      }}
    >
      <Flex
        align="center"
        direction="column"
        gap={24}
        style={{
          padding: '8px 24px 12px 24px',
        }}
      >
        <CheckCircleFilled
          style={{
            fontSize: 36,
            color: semanticColors.success.medium,
          }}
        />
        <Flex direction="column" align="center">
          <Typography.Title level={5}>
            연동이 완료되면 아래 이메일로 안내드리겠습니다
          </Typography.Title>
          <Typography.Text
            style={{
              color: colorTokens.textDescription,
            }}
          >
            영업일 기준 1시간 이내 소요됩니다
          </Typography.Text>
        </Flex>
        <Flex direction="column" align="center">
          {emails.map((email) => {
            return <Typography.Text key={email}>{email}</Typography.Text>;
          })}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConnectSuccessModal;
